import React, {
    useState,
    useEffect
} from 'react';

import {
    useDispatch,
    useSelector
} from 'react-redux';

import {
    Link,
    useNavigate
} from 'react-router-dom';


// Actions
import {
    iniciarSesionAction
} from '../../actions/loginActions';

import {
    setearAlerta,
    ocultarAlertaAction
} from '../../actions/alertaActions';


// CSS
import {
    PaginaAuth,
    HeaderAuth,
    LogoLink,
    Logo,
    HeaderAcciones,
    LinkHeader,

    ContenidoAuth,
    PanelIlustracion,
    ImagenAuth,

    TarjetaAuth,
    EncabezadoAuth,
    TituloAuth,

    EtiquetaGrupo,
    TipoGrid,
    TipoButton,

    FormularioAuth,
    CampoAuth,
    LabelAuth,
    InputAuth,

    CampoPassword,
    InputPassword,
    BotonOjo,
    IconoOjo,

    BotonPrincipalAuth,

    LinksAuth,
    LinkAuth,

    MensajeAuth
} from '../Css/StyledAuth';


const Login = () => {

    const dispatch =
        useDispatch();


    const navigate =
        useNavigate();


    /*
    ========================================
    FORM
    ========================================
    */

    const [
        email,
        guardarEmail
    ] =
        useState('');


    const [
        password,
        guardarPassword
    ] =
        useState('');


    /*
    Profesional queda seleccionado
    por defecto.
    */

    const [
        tipoUsuario,
        setTipoUsuario
    ] =
        useState(
            'Profesional'
        );


    const [
        visibilidadPassword,
        setVisibilidadPassword
    ] =
        useState(false);


    /*
    ========================================
    REDUX
    ========================================
    */

    const cargando =
        useSelector(
            state =>
                state.estado.loading
        );


    const error =
        useSelector(
            state =>
                state.estado.error
        );


    const alerta =
        useSelector(
            state =>
                state.alertas.alerta
        );


    const autenticado =
        useSelector(
            state =>
                state.autenticado
                    .autenticado
        );


    const rol =
        useSelector(
            state =>
                state.usuario.rol
        );


    /*
    ========================================
    CAMBIAR TIPO
    ========================================
    */

    const cambiarTipoUsuario = (
        nuevoTipo
    ) => {

        dispatch(
            ocultarAlertaAction()
        );


        setTipoUsuario(
            nuevoTipo
        );

    };


    /*
    ========================================
    LOGIN
    ========================================
    */

    const submitLogin = (
        e
    ) => {

        e.preventDefault();


        const emailLimpio =
            email
                .trim()
                .toLowerCase();


        if (
            !emailLimpio
        ) {

            dispatch(
                setearAlerta({
                    msg:
                        'Falta completar el email'
                })
            );


            return;

        }


        const emailValido =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                .test(
                    emailLimpio
                );


        if (
            !emailValido
        ) {

            dispatch(
                setearAlerta({
                    msg:
                        'Ingresá un email válido'
                })
            );


            return;

        }


        if (
            !password
        ) {

            dispatch(
                setearAlerta({
                    msg:
                        'Debe escribir una contraseña'
                })
            );


            return;

        }


        dispatch(
            ocultarAlertaAction()
        );


        dispatch(
            iniciarSesionAction({

                email:
                    emailLimpio,

                password,

                tipoUsuario

            })
        );

    };


    /*
    ========================================
    REDIRECCIÓN
    ========================================
    */

    useEffect(
        () => {

            if (
                !autenticado
            ) {

                return;

            }


            if (
                rol ===
                '249831'
            ) {

                navigate(
                    '/gestion'
                );


                return;

            }


            if (
                tipoUsuario ===
                'Screening'
            ) {

                navigate(
                    '/escritorio/screening'
                );


                return;

            }


            if (
                tipoUsuario ===
                'Profesional'
            ) {

                navigate(
                    '/escritorio/calendario'
                );


                return;

            }


            if (
                tipoUsuario ===
                'Paciente'
            ) {

                navigate(
                    '/escritorio-paciente'
                );

            }

        },
        [
            autenticado,
            rol,
            tipoUsuario,
            navigate
        ]
    );


    /*
    ========================================
    MENSAJES
    ========================================
    */

    const mensajeError =

        typeof error ===
        'string'

            ?
            error

            :
            error?.msg ||
            '';


    const nombreTipo =

        tipoUsuario ===
        'Paciente'

            ?
            'Entrenado'

            :
            tipoUsuario;


    return (

        <PaginaAuth>


            <HeaderAuth>


                <LogoLink
                    as={Link}
                    to="/"
                >

                    <Logo
                        src="/img/metodoYogenLogo_recortado.png"
                        alt="Método YÖGEN"
                    />

                </LogoLink>


                <HeaderAcciones>


                    {
                        tipoUsuario ===
                        'Profesional' && (

                            <LinkHeader
                                as={Link}
                                to="/nueva-cuenta"
                            >

                                Nueva cuenta profesional

                            </LinkHeader>

                        )
                    }


                </HeaderAcciones>


            </HeaderAuth>


            <ContenidoAuth>


                <PanelIlustracion>


                    <ImagenAuth

                        src={
                            tipoUsuario ===
                            'Paciente'

                                ?
                                '/img/login_entrenado.png'

                                :
                                '/img/ilustracionLogIn.png'
                        }

                        alt=""

                    />


                </PanelIlustracion>


                <TarjetaAuth>


                    <EncabezadoAuth>


                        <TituloAuth>

                            Bienvenido {
                                nombreTipo
                            }, iniciá sesión

                        </TituloAuth>


                    </EncabezadoAuth>


                    <EtiquetaGrupo>
                        Tipo de cuenta
                    </EtiquetaGrupo>


                    <TipoGrid>


                        <TipoButton

                            type="button"

                            $activo={
                                tipoUsuario ===
                                'Profesional'
                            }

                            onClick={() =>
                                cambiarTipoUsuario(
                                    'Profesional'
                                )
                            }

                        >

                            Profesional

                        </TipoButton>


                        <TipoButton

                            type="button"

                            $activo={
                                tipoUsuario ===
                                'Paciente'
                            }

                            onClick={() =>
                                cambiarTipoUsuario(
                                    'Paciente'
                                )
                            }

                        >

                            Entrenado

                        </TipoButton>


                        <TipoButton

                            type="button"

                            $activo={
                                tipoUsuario ===
                                'Screening'
                            }

                            onClick={() =>
                                cambiarTipoUsuario(
                                    'Screening'
                                )
                            }

                        >

                            Screening

                        </TipoButton>


                    </TipoGrid>


                    <FormularioAuth
                        onSubmit={
                            submitLogin
                        }
                        noValidate
                    >


                        <CampoAuth>


                            <LabelAuth
                                htmlFor="email"
                            >

                                Email

                            </LabelAuth>


                            <InputAuth

                                type="email"

                                id="email"

                                name="email"

                                autoComplete="email"

                                value={
                                    email
                                }

                                disabled={
                                    cargando
                                }

                                onChange={
                                    e => {

                                        guardarEmail(
                                            e.target.value
                                        );


                                        if (
                                            alerta
                                        ) {

                                            dispatch(
                                                ocultarAlertaAction()
                                            );

                                        }

                                    }
                                }

                            />


                        </CampoAuth>


                        <CampoAuth>


                            <LabelAuth
                                htmlFor="password"
                            >

                                Contraseña

                            </LabelAuth>


                            <CampoPassword>


                                <InputPassword

                                    type={
                                        visibilidadPassword
                                            ?
                                            'text'
                                            :
                                            'password'
                                    }

                                    id="password"

                                    name="password"

                                    autoComplete="current-password"

                                    value={
                                        password
                                    }

                                    disabled={
                                        cargando
                                    }

                                    onChange={
                                        e =>
                                            guardarPassword(
                                                e.target.value
                                            )
                                    }

                                />


                                <BotonOjo

                                    type="button"

                                    onClick={() =>
                                        setVisibilidadPassword(
                                            valor =>
                                                !valor
                                        )
                                    }

                                    aria-label={
                                        visibilidadPassword
                                            ?
                                            'Ocultar contraseña'
                                            :
                                            'Mostrar contraseña'
                                    }

                                >

                                    <IconoOjo

                                        src={
                                            visibilidadPassword
                                                ?
                                                '/img/ojo_invisible.png'
                                                :
                                                '/img/ojo_visible.png'
                                        }

                                        alt=""

                                    />

                                </BotonOjo>


                            </CampoPassword>


                        </CampoAuth>


                        <BotonPrincipalAuth

                            type="submit"

                            disabled={
                                cargando
                            }

                        >

                            {
                                cargando
                                    ?
                                    'Iniciando sesión...'
                                    :
                                    'Iniciar sesión'
                            }

                        </BotonPrincipalAuth>


                    </FormularioAuth>


                    <LinksAuth>


                        <LinkAuth
                            as={Link}
                            to="/restablecer-password"
                        >

                            ¿Has olvidado tu contraseña?

                        </LinkAuth>


                    </LinksAuth>


                    {
                        mensajeError && (

                            <MensajeAuth $error>

                                {
                                    mensajeError
                                }

                            </MensajeAuth>

                        )
                    }


                    {
                        alerta?.msg && (

                            <MensajeAuth $error>

                                {
                                    alerta.msg
                                }

                            </MensajeAuth>

                        )
                    }


                </TarjetaAuth>


            </ContenidoAuth>


        </PaginaAuth>

    );

};


export default Login;